"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adapt2Runtime = void 0;
var utils_1 = require("./../utils");
var helpers_1 = require("../helpers");
var adapt2Runtime = function (dataSource, context, extraConfig) {
    var interpretConfigList = dataSource.list, interpretDataHandler = dataSource.dataHandler;
    var dataHandler = interpretDataHandler
        ? (0, utils_1.getRuntimeJsValue)(interpretDataHandler, context)
        : undefined;
    // 为空判断
    if (!interpretConfigList || !interpretConfigList.length) {
        return {
            list: [],
            dataHandler: dataHandler,
        };
    }
    var list = interpretConfigList.map(function (el) {
        var customDataHandler = extraConfig.defaultDataHandler;
        var finalDataHandler = customDataHandler || helpers_1.defaultDataHandler;
        return {
            id: el.id,
            isInit: (0, utils_1.getRuntimeValueFromConfig)('boolean', el.isInit, context),
            isSync: (0, utils_1.getRuntimeValueFromConfig)('boolean', el.isSync, context),
            type: el.type || 'fetch',
            willFetch: el.willFetch ? (0, utils_1.getRuntimeJsValue)(el.willFetch, context) : helpers_1.defaultWillFetch,
            shouldFetch: (0, utils_1.buildShouldFetch)(el, context),
            dataHandler: el.dataHandler ? (0, utils_1.getRuntimeJsValue)(el.dataHandler, context) : finalDataHandler,
            errorHandler: el.errorHandler ? (0, utils_1.getRuntimeJsValue)(el.errorHandler, context) : undefined,
            requestHandler: el.requestHandler ? (0, utils_1.getRuntimeJsValue)(el.requestHandler, context) : undefined,
            options: (0, utils_1.buildOptions)(el, context),
        };
    });
    return {
        list: list,
        dataHandler: dataHandler,
    };
};
exports.adapt2Runtime = adapt2Runtime;
